<app-dialog-base class="modalobjectphoto" [Title]='"Object files"|translate' [dialogId]="dialogId" (onClose)="close()" [height]="'550px'" [ExitButton]="true">
  <div class="gallery">
    <button id="prev_file" class="btn_prev"></button>
    <div class="photo">
      <img id="photofromdevice" src="/assets/icons/noimg.png" />
    </div>
    <button id="next_file" class="btn_next"></button>
  </div>
</app-dialog-base>
